import React from 'react'
// import { EMPTY_ARRAY } from '../../constants/globalConstants'
import GooglePayDC from './GooglePayDC'
import ApplePayDataCap from './ApplePayDataCap'
import DatatransWallet from './DatatransWallet'
import GooglePayHL from './GooglePayHL'
import ApplePayHL from './ApplePayHL'
// import { Circles } from 'react-loader-spinner'
import './wallet.scss'
import GooglePayFS from './Fiserv/GooglePayFS'
import ApplePayBtnFS from './Fiserv/ApplePayFS'

const renderWalletButtons = (props) => {
    const {
        dispatch,
        faciltyData,
        getValues,
        onSubmit,
        setIsSubmittingForm,
        isSubmittingForm,
        setIsLoading,
        payableAmount,
        isIOSDevice,
        applePaySessionRef,
        notify
    } = props
    // const [paymentGateWay, setPaymentGateyway] = useState(null)
    // const loaded = useRef(false)
    // console.log(faciltyData, 'I am here')

    // useEffect(() => {
    //     const paymentGateway = faciltyData?.facility_payment_details?.facility_payment_type_id
    //     setPaymentGateyway(paymentGateway)
    // },[EMPTY_ARRAY, faciltyData?.full_name])
    return(
        // isSubmittingForm ? <div className='container'>
        //     <div className=' d-flex justify-content-center p-2 border-grey border border-2 border-primary border-opacity-50 rounded'>
        //         <p className='mb-0'>Please wait...</p> <span className='ms-2'><Circles
        //             height="20"
        //             width="20"
        //             color='text-primary'
        //             style={{ display: 'inline-block' }}
        //             ariaLabel="circles-loading"
        //             visible={true}
        //         />
        //         </span>
        //     </div>
        // </div> :
        <>
            {faciltyData?.facility_payment_details?.facility_payment_type_id == 1 ? <>
                {(faciltyData?.facility_payment_details?.data_trans_username_web && faciltyData?.facility_payment_details?.data_trans_merchant_name && faciltyData?.facility_payment_details?.data_trans_gpay_merchant) ? <DatatransWallet notify={notify} faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm} setIsLoading={setIsLoading} payableAmount={payableAmount}/> : null}
            </> : faciltyData?.facility_payment_details?.facility_payment_type_id == 2 ? <>
                {(faciltyData?.facility_payment_details?.wallet_datacap_token && faciltyData?.facility_payment_details?.wallet_datacap_mid && faciltyData?.facility_payment_details?.wallet_datacap_gpay_merchant) ? <> {isIOSDevice ?
                    <ApplePayDataCap notify={notify} faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm} setIsLoading={setIsLoading} payableAmount={payableAmount}/>
                    : <GooglePayDC notify={notify} faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm} setIsLoading={setIsLoading} payableAmount={payableAmount}/>}
                </> : null}
            </>  : faciltyData?.facility_payment_details?.facility_payment_type_id == 3 ? <>
                {isIOSDevice ?
                    <ApplePayBtnFS faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm} dispatch={dispatch} applePaySessionRef={applePaySessionRef} payableAmount={payableAmount}/>
                    : <GooglePayFS faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm} isSubmittingForm={isSubmittingForm} dispatch={dispatch} payableAmount={payableAmount}/>}
            </>
            : faciltyData?.facility_payment_details?.facility_payment_type_id == 4 ? <>
                {faciltyData?.facility_payment_details?.heartland_mid ? <>
                    {isIOSDevice ? <ApplePayHL notify={notify} faciltyData={faciltyData} getValues={getValues} setIsSubmittingForm={setIsSubmittingForm} onSubmit={onSubmit} setIsLoading={setIsLoading} payableAmount={payableAmount} applePaySessionRef={applePaySessionRef} />
                    : <GooglePayHL notify={notify} faciltyData={faciltyData} getValues={getValues} onSubmit={onSubmit} setIsSubmittingForm={setIsSubmittingForm} setIsLoading={setIsLoading} payableAmount={payableAmount} /> }
                </> : null}
            </> : null}
        </>
    )

}
export default renderWalletButtons